import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';


const languages = [
  { code: 'kz', label: 'Қазақша' },
  // { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
];

const LanguageSelectDialog = (props) => {
  const { onClose, selectLanguage, open } = props;

  const handleLanguageClick = (code) => {
    selectLanguage(code);
    onClose();
  };

  return (
    <Dialog
      open={open}
      maxWidth='xs'
      fullWidth
    >
      <div>
        <List sx={{ pt: 0 }}>
          {languages.map(({ code, label }) => (
            <ListItem button onClick={() => handleLanguageClick(code)} key={code}>
              {/* <ListItemAvatar> */}
              {/* TODO: add flags */}
              {/* </ListItemAvatar> */}
              <ListItemText primary={label} style={{ textAlign: 'center' }} />
            </ListItem>
          ))}
        </List>
      </div>
    </Dialog>
  );
}

export default LanguageSelectDialog;
